import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { printNumber } from "../../utils/helpers";

import "./styles.css";

const TowCableResults = ({ results }) => {
	const { t } = useTranslation();

	return (
		<IonGrid>
			<IonRow>
				<IonCol size="7">
					<strong>{t("system.towCable.minCableDiameter")}</strong>
				</IonCol>
				<IonCol className="ion-text-center">
					<span>{ printNumber(results?.minCableDiameter.value) } mm</span>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol size="7">
					<strong>{t("system.towCable.maxCableDiameter")}</strong>
				</IonCol>
				<IonCol className="ion-text-center">
					<span>{ printNumber(results?.maxCableDiameter.value) } mm</span>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol size="7">
					<strong>{t("system.towCable.minWeight")}</strong>
				</IonCol>
				<IonCol className="ion-text-center">
					<span>{ printNumber(results?.minWeight.value) } kg/m</span>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol size="7">
					<strong>{t("system.towCable.maxWeightAM")}</strong>
				</IonCol>
				<IonCol className="ion-text-center">
					<span>{ printNumber(results?.maxWeightAM.value) } kg/m</span>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol size="7">
					<strong>{t("system.towCable.maxWeightAT")}</strong>
				</IonCol>
				<IonCol className="ion-text-center">
					<span>{ printNumber(results?.maxWeightAT.value) } kg/m</span>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol size="7">
					<strong>{t("system.towCable.minBreakingLoad")}</strong>
				</IonCol>
				<IonCol className="ion-text-center">
					<span>{ printNumber(results?.minBreakingLoad.value) } kN</span>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol size="7">
					<strong>{t("system.towCable.maxBreakingLoadAM")}</strong>
				</IonCol>
				<IonCol className="ion-text-center">
					<span>{ printNumber(results?.maxBreakingLoadAM.value) } kN</span>
				</IonCol>
			</IonRow>
			<IonRow>
				<IonCol size="7">
					<strong>{t("system.towCable.maxBreakingLoadAT")}</strong>
				</IonCol>
				<IonCol className="ion-text-center">
					<span>{ printNumber(results?.maxBreakingLoadAT.value) } kN</span>
				</IonCol>
			</IonRow>
		</IonGrid>
	);
};

export default TowCableResults;
